export default "__VITE_ASSET__B$x2Fv$H__"